<template>
  <div class="sticky-container">
    <div class="sticky">
      <div class="btn-group btn-group-lg">
        <slot />

        <RouterLink
          v-if="temVoltar"
          id="botaoVoltar"
          data-test-id="link-cancelar"
          :to="voltar"
          name="botaoVoltar"
          role="button"
          class="btn btn-danger"
        >
          <span class="fa fa-trash fa-lg" /> Cancelar
        </RouterLink>
        <button
          id="botaoSalvar"
          data-test-id="button-salvar"
          name="botaoSalvar"
          type="submit"
          class="btn btn-success"
          :disabled="!podeSalvar"
        >
          <span class="fa fa-save fa-lg" /> Salvar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ToolbarCadastro',
  props: {
    temVoltar: {
      type: Boolean,
      default: true,
    },
    voltar: {
      type: String,
      required: false,
      default: () => {
        return '/'
      },
    },
    podeSalvar: {
      type: Boolean,
      default: true,
    },
  },
}
</script>

<style scoped>
.sticky {
  z-index: 4;
  padding: 10px;
}

.sticky-container {
  position: -webkit-sticky;
  position: sticky;
  bottom: 0;
  z-index: 4;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  align-items: baseline;
  justify-content: flex-end;
  width: 100%;
  margin: auto;
  margin-bottom: 50px;
}

.btn-group {
  box-shadow:
    0 1px 3px rgba(0, 0, 0, 0.12),
    0 1px 2px rgba(0, 0, 0, 0.24);
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.btn-group:hover {
  box-shadow:
    0 11px 28px rgba(0, 0, 0, 0.25),
    0 7px 10px rgba(0, 0, 0, 0.22);
}
</style>
